import { render, staticRenderFns } from "./Extracurriculars.vue?vue&type=template&id=584c3edf&scoped=true&"
import script from "./Extracurriculars.vue?vue&type=script&lang=js&"
export * from "./Extracurriculars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584c3edf",
  null
  
)

export default component.exports